import type { JourneyDetail } from "@/app/services/generated/journeyv1Service";
import { JourneyService } from "@/app/services/generated/journeyv1Service";
import type { JourneyDetail as JourneyDetailV2 } from "@/app/services/generated/journeyv2Service";

export default class JourneyServiceExtended extends JourneyService {
  public journeyInProgress(journeyDetail: JourneyDetail | JourneyDetailV2) {
    return (
      journeyDetail.journey.readOnly.startedAt &&
      !journeyDetail.journey.readOnly.endedAt
    );
  }
}

export const journeyService = new JourneyServiceExtended();
